import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  connect() {
    // Show battery image by default
    this.hideAllImages()
    this.showImage("battery")
  }

  revealImage(event) {
    const part = event.currentTarget.dataset.statsRevealPart
    this.hideAllImages()
    this.showImage(part)
  }

  hideImage() {
    this.hideAllImages()
    this.showImage("battery") // Default back to battery view
  }

  hideAllImages() {
    this.imageTargets.forEach((img) => {
      img.classList.add("opacity-0")
      img.classList.remove("opacity-100")
    })
  }

  showImage(part) {
    const image = this.imageTargets.find((img) => img.dataset.statsRevealPart === part)
    if (image) {
      image.classList.remove("opacity-0")
      image.classList.add("opacity-100")
    }
  }
}

